
export default {
    name: 'modifyPassword',
    title: '密码修改',
    component: () => import('../../../views/dialog/ModifyPassword')
}
